var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M180 40v40c0 22.093 17.91 40.001 40 40.001h40V220c0 11.046-8.954 20-20 20H40c-11.046 0-20-8.954-20-20V60c0-11.046 8.954-20 20-20zM70 102.46v85.08c0 10.544 12.959 16.304 21.494 9.554l53.791-42.54c6.287-4.972 6.287-14.136 0-19.108l-53.79-42.54C82.958 86.156 70 91.916 70 102.46M200 40l60 60h-40c-11.045 0-20-8.954-20-20z"
})));
export default SvgFileVideo;